import React from "react";

const tabs = [
  {
    key: "display",
    emoji: "⚙️",
    title: "Display Settings",
    subtitle: "Create & Edit",
  },
  {
    key: "start",
    emoji: "▶️",
    title: "Start Now",
    subtitle: "Go Live",
  },
  {
    key: "live",
    emoji: "📊",
    title: "Live Feed",
    subtitle: "Monitor",
  },
  {
    key: "stop",
    emoji: "⏹️",
    title: "Stop",
    subtitle: "End Event",
  },
  {
    key: "winner",
    emoji: "🏆",
    title: "Winners",
    subtitle: "Celebrate",
  },
];

const ReunionDashboardTabs = ({ activeTab, setActiveTab }) => {
  return (
    <section className="sticky top-0 z-30 backdrop-blur-xl bg-[#07110f]/90 border-b border-emerald-500/20">
      <div className="max-w-7xl mx-auto px-3 py-3">
        <div className="grid grid-cols-2 lg:grid-cols-5 gap-3">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`
                rounded-2xl
                border
                p-4
                transition-all
                duration-300
                text-center

                ${
                  activeTab === tab.key
                    ? "bg-gradient-to-r from-emerald-500 to-green-600 border-emerald-300 shadow-xl shadow-emerald-500/30 scale-[1.02]"
                    : "bg-white/5 border-white/10 hover:bg-white/10 hover:border-emerald-400/40"
                }
              `}
            >
              <div className="text-3xl mb-2">{tab.emoji}</div>

              <div className="font-bold text-sm lg:text-base text-white">
                {tab.title}
              </div>

              <div
                className={`
                  text-xs mt-1

                  ${activeTab === tab.key ? "text-white" : "text-emerald-200"}
                `}
              >
                {tab.subtitle}
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReunionDashboardTabs;
